/*MAIN COMPOMEMT */

import { addMinutes, format, parse, startOfDay } from 'date-fns';
import {
  PhoneNumberFormat,
  PhoneNumberUtil
} from 'google-libphonenumber';
import Cookies from "js-cookie";

import * as XLSX from "xlsx";
import { ItemAccountPlan, ItemCharges, ItemNotification, ItemUser, MenuItem } from '../../resources/types';

import { globalStateStore } from '../context/GlobalStateContext';

export const setVersion = (id: string) => globalStateStore.setVersion?.(id) ?? localStorage.setItem('version', id.toString());
export const setSdk = (id: string) => globalStateStore.setSdk?.(id) ?? localStorage.setItem('sdk', id.toString());
export const setDisplayName = (id: string) => globalStateStore.setDisplayName?.(id) ?? localStorage.setItem('displayName', id.toString());
export const setLoading = (id: boolean) => globalStateStore.setLoading?.(id) ?? localStorage.setItem('loading', id.toString());
export const setJWT = (id: string) => globalStateStore.setJWT?.(id) ?? localStorage.setItem('JWT', id.toString());
export const setReturnUrl = (id: string) => globalStateStore.setReturnUrl?.(id) ?? localStorage.setItem('returnUrl', id.toString());
export const setRUT = (id: string) => globalStateStore.setRUT?.(id) ?? localStorage.setItem('RUT', id.toString());
export const setPhone = (id: string) => globalStateStore.setPhone?.(id) ?? localStorage.setItem('phone', id.toString());
export const setIdUser = (id: number) => globalStateStore.setIdUser?.(id) ?? localStorage.setItem('idUser', id.toString());




export const setData = (value: Record<string, any> | ((prev: Record<string, any>) => Record<string, any>)) => {
  if (globalStateStore.setData) {
    globalStateStore.setData(value);
  } else {
    const current = JSON.parse(localStorage.getItem('data') || '{}');
    const next = typeof value === 'function' ? value(current) : value;
    localStorage.setItem('data', JSON.stringify(next));
  }
};
export const setParameters = (value: Record<string, any> | ((prev: Record<string, any>) => Record<string, any>)) => {
  if (globalStateStore.setParameters) {
    globalStateStore.setParameters(value);
  } else {
    const current = JSON.parse(localStorage.getItem('parameters') || '{}');
    const next = typeof value === 'function' ? value(current) : value;
    localStorage.setItem('parameters', JSON.stringify(next));
  }
};

export const setMenu = (
  value: MenuItem[] | ((prev: MenuItem[]) => MenuItem[])
) => {
  if (globalStateStore.setMenu) {
    globalStateStore.setMenu(value);
  } else {
    const currentRaw = localStorage.getItem('menu');
    const current: MenuItem[] = currentRaw ? JSON.parse(currentRaw) : [];
    const next = typeof value === 'function' ? value(current) : value;
    localStorage.setItem('menu', JSON.stringify(next));
  }
};

export const setNotifications = (
  value: ItemNotification[] | ((prev: ItemNotification[]) => ItemNotification[])
) => {
  if (globalStateStore.setNotifications) {
    globalStateStore.setNotifications(value);
  } else {
    const currentRaw = localStorage.getItem('notifications');
    const current: ItemNotification[] = currentRaw ? JSON.parse(currentRaw) : [];
    const next = typeof value === 'function' ? value(current) : value;
    localStorage.setItem('notifications', JSON.stringify(next));
  }
};
export const setCounters = (value: Record<string, any> | ((prev: Record<string, any>) => Record<string, any>)) => {
  if (globalStateStore.setCounters) {
    globalStateStore.setCounters(value);
  } else {
    const current = JSON.parse(localStorage.getItem('counters') || '{}');
    const next = typeof value === 'function' ? value(current) : value;
    localStorage.setItem('counters', JSON.stringify(next));
  }
};



export function normalizeDate(date: any) {
  if (date) {
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
  }
  return "";
}
export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const value = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));
  return `${value} ${sizes[i]}`;
}
export function parseDotNetDate(jsonDate: { match: (arg0: RegExp) => string[]; }) {
  // Extract the number between parentheses
  if (jsonDate) {
    const timestamp = parseInt(jsonDate.match(/\d+/)[0], 10);
    return new Date(timestamp);
  }
  return ""
}

export function isPhoneValid(phone: any): boolean {
  const phoneUtil = PhoneNumberUtil.getInstance();

  // 1. Manejo de nulos y vacíos
  if (!phone) return false;

  // 2. Limpieza de caracteres no numéricos
  let cleaned = phone.toString().replace(/\D/g, '');
  if (cleaned.length > 3) {
    if (cleaned === '56912345678') {
      return true;
    }

    try {
      const number = phoneUtil.parse('+' + cleaned, '');
      return phoneUtil.isValidNumber(number);

    } catch (error) {
    }
  }
  return false;
}

export function statusCheck(idStatusRequest: number): string {
  if (idStatusRequest === -1) return "Anulado"
  if (idStatusRequest === -2) return "Expirado"
  if (idStatusRequest === 0) return "Pendiente"
  if (idStatusRequest === 1) return "Asignado"
  if (idStatusRequest === 2) return "Rechzadado"
  if (idStatusRequest === 3) return "Aprobado"
  if (idStatusRequest === 4) return "Aprobado con observaciones"

  return "";
}
export function validPhone(phone: any): boolean {
  const phoneUtil = PhoneNumberUtil.getInstance();
  if (!phone) false;
  let cleaned = phone.toString().replace(/\D/g, '');
  try {
    const number = phoneUtil.parse('+' + cleaned, '');
    return (phoneUtil.isValidNumber(number))
  } catch (error) {
    return false;
  }
}
export function formatPhone(phone: any): string {
  const phoneUtil = PhoneNumberUtil.getInstance();

  // 1. Manejo de nulos y vacíos
  if (!phone) return "";

  // 2. Limpieza de caracteres no numéricos
  let cleaned = phone.toString().replace(/\D/g, '');
  if (cleaned.length > 3) {
    if (cleaned === '56912345678') {
      return '+56 9 1234 5678';
    }

    try {
      const number = phoneUtil.parse('+' + cleaned, '');
      if (phoneUtil.isValidNumber(number)) {
        return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
      }
    } catch (error) {
    }
  }
  return cleaned.trim();
}

export function sanitizeNumber(value: any, decimals: number = 2) {
  if (!value) return "";

  // Replace comma with dot and remove invalid characters
  if (decimals === 0) {
    value = value.toString().replace(",", "").replace(".", "")
  } else {
    value = value.toString().replace(",", ".")
  }
  value = value.toString().replace(/[^0-9.]/g, '');

  // Allow only one decimal point
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts[1];
  }

  // Remove leading zeros from integer part
  if (parts[0]) {
    parts[0] = parts[0].replace(/^0+(?=\d)/, ''); // keep single 0 if number is 0
  }

  // Limit decimal digits
  if (parts[1]) {
    parts[1] = parts[1].substring(0, decimals);
  }

  return parts.join('.');
}
export function getAccountPlan(idAccountPlan: number, data: any) {
  if (data && data.accountPlans) {
    //const user = data.users.find((u: { idUser: number; }) => u.idUser === idUser);
    const accountPlan: ItemAccountPlan | undefined = data.accountPlans.find(
      (u: ItemAccountPlan) => u.idAccountPlan === idAccountPlan
    );
    return accountPlan; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}

export function getUser(idUser: number, data: any) {
  if (data && data.users) {
    //const user = data.users.find((u: { idUser: number; }) => u.idUser === idUser);
    const user: ItemUser | undefined = data.users.find(
      (u: ItemUser) => u.idUser === idUser
    );
    return user; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}

export function getCharge(idCharge: number, data: any) {
  if (data && data.charges) {
    const charge: ItemCharges | undefined = data.charges.find(
      (u: ItemCharges) => u.idCharge === idCharge
    );
    return charge;
  }
  return null; // fallback if data or users is undefined
}

export function getEquipment(idEquipment: number, data: any) {
  if (data && data.equipments) {
    const equipment = data.equipments.find((u: { idEquipment: number; }) => u.idEquipment === idEquipment);
    return equipment; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}

export function getCategory(idCategory: number, data: any) {
  if (data && data.categories) {
    const categories = data.categories.find((u: { idCategory: number; }) => u.idCategory === idCategory);
    return categories; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
export function getGroupType(idGroupType: number, data: any) {
  if (data && data.equipments) {
    const groupTypes = data.groupTypes.find((u: { idGroupType: number; }) => u.idGroupType === idGroupType);
    return groupTypes; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
export function getUserType(idUserType: number, data: any) {
  if (data && data.usersTypes) {
    const userType = data.usersTypes.find((u: { idUserType: number; }) => u.idUserType === idUserType);
    return userType; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}
export function getUserGroup(idGroup: number, data: any) {
  if (data && data.groups) {
    const userGroup = data.groups.find((u: { idGroup: number; }) => u.idGroup === idGroup);
    return userGroup; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}

export function getBookingType(idBookingType: number, data: any) {
  if (data && data.bookingTypes) {
    const bookingType = data.bookingTypes.find((u: { idBookingType: number; }) => u.idBookingType === idBookingType);
    return bookingType; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}

export function getMenu(url: string, menu: any) {
  if (!!menu) {
    const flattenMenu = (items: MenuItem[]) => {
      return items.reduce((acc, item) => {
        acc.push(item);
        if (item.items && Array.isArray(item.items)) {
          acc.push(...flattenMenu(item.items));
        }
        return acc;
      }, []);
    };
    const allMenuItems = flattenMenu(menu);
    const oMenu = allMenuItems.find(item => item.href.replace("#", "") === url)
    return oMenu; // or handle if user is not found
  }
  return null; // fallback if data or users is undefined
}


//const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState();
export function storeCounters(data: any, setInvoicesExpired: (invoicesExpired: number) => void, setPendingAuth: (pendingAuth: number) => void, setShowPropertiesSelector: (token: number) => void) {
  if (data && data.admin && data.admin.properties) {
    setShowPropertiesSelector(data.admin.properties.length)
  }
  if (data && data.admin && data.admin.counters) {
    setInvoicesExpired(data.admin.counters.invoicesExpired)
    setPendingAuth(data.admin.counters.pendingAuth)
  }
}

export function storeJWT(data: any) {
  //const { setServerVersion, setMenu, setNotifications, setIdUser, setDisplayName } = globalState;


  /*
  if (data?.JWT) {
    setJWT(data.JWT);
    localStorage.setItem("JWT", data.JWT);
  }
    */
  if (data?.idUser) {
    setIdUser(data.idUser);
    //localStorage.setItem("idUser", data.idUser);
  }
  if (data?.displayName) {
    setDisplayName(data.displayName);
    localStorage.setItem("displayName", data.displayName);
  }

  if (data && data?.notifications) {
    setNotifications(data.notifications)
    // localStorage.setItem("notifications", JSON.stringify(data.notifications));
  }
  if (data && data.admin && data.admin.menu) {
    setMenu(data.admin.menu)
  }

  if (data?.menu && typeof setMenu === 'function') {
    //setMenu(data.menu);
    //localStorage.setItem("menu", JSON.stringify(data.menu));
  }
}
export function isEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
export function checkHashParam(paramName: any) {
  if (paramName === undefined || paramName.toString() === "") return undefined;
  const hash = window.location.hash;
  if (hash.indexOf("?") === -1) return undefined;
  const queryString = hash.split('?')[1];
  const params = new URLSearchParams(queryString);
  if (!params.has(paramName)) return undefined;
  return params.get(paramName);
};
export function getParameter(hash: string, parameter: string) {
  let queryParams = new URLSearchParams();
  let hashNow = hash.substring(1);
  let extractedReturnUrl = ''
  const questionMarkIndex = window.location.hash.indexOf('?');
  if (questionMarkIndex !== -1) {
    if (parameter === "") {
      let rt = hash.substring(questionMarkIndex + 1);

    } else {
      hashNow = hashNow.substring(0, questionMarkIndex - 1);
      let queryString = hash.substring(questionMarkIndex + 1);
      queryParams = new URLSearchParams(queryString);
      extractedReturnUrl = queryParams.get(parameter) || '';
    }
  }
  return extractedReturnUrl;
}
export function hideKeyboardGlobally() {
  const activeElement = document.activeElement;

  if (activeElement) {
    setTimeout(() => {
      (activeElement as HTMLElement).blur();
    }, 500)
  }
}
export function getHash(hash: string) {

  let hashNow = hash.substring(1);
  const questionMarkIndex = window.location.hash.indexOf('?');
  let queryString = '';
  let queryParams = new URLSearchParams();
  let rUrl: string | null = '';
  if (questionMarkIndex !== -1) {

    hashNow = hash.substring(0, questionMarkIndex);
    queryString = hash.substring(questionMarkIndex + 1);
    queryParams = new URLSearchParams(queryString);
    const extractedReturnUrl = queryParams.get('returnUrl');
    rUrl = extractedReturnUrl;
  }
  return hashNow;
}
export function isValidPhone(phone: any) {
  const phoneUtil = PhoneNumberUtil.getInstance();
  if (phone) {
    phone = phone.replace(/\D/g, '')
    if (phone.length > 3) {
      if (phone == '56912345678') {
        return true;
      } else {
        try {
          const number = phoneUtil.parse('+' + phone.toString(), undefined); // No region for initial parse
          return (phoneUtil.isValidNumber(number)); // Check if it's a possible number for any region
        } catch (error) {
          // If parsing fails, it's likely not a recognizable phone number format, keep disabled
          return false;
        }
      }
    }
  }
  return false;
}
export const fileToBase64 = (file: File): Promise<{ base64: string; file: File }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // When the file reading is complete
    reader.onload = () => {
      // The result will be a data URL (e.g., "data:image/png;base64,iVB...")
      // We strip the header (e.g., "data:image/png;base64,") to get pure Base64
      const base64String = reader.result ? (reader.result as string).split(',')[1] : '';
      resolve({ base64: base64String, file });
    };

    // Handle errors during reading
    reader.onerror = (error) => reject(error);

    // Read the file content as a Data URL (which contains Base64)
    reader.readAsDataURL(file);
  });
};

export function isJWTExpired(token: string): boolean {
  if (!token) return true; // No token = expired

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = JSON.parse(atob(base64));

    if (!decodedPayload.exp) {
      return true; // No exp = consider expired
    }
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    return decodedPayload.exp < now;
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return true; // Invalid token = expired
  }
}

type Currency = "CLP" | "UF" | string;

export function formatCurrency(
  value: number,
  currency: any
): string {


  let minimumFractionDigits = 2;
  let crr = currency
  if (typeof crr === "number") {
    minimumFractionDigits = currency;
    crr = "CLP"
  } else {
    crr = currency
    if (currency === "UF") {
      crr = "CLP"
      minimumFractionDigits = 2;
    } else if (currency === "CLP") {
      minimumFractionDigits = 0;
    }
  }


  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: crr,
    minimumFractionDigits,
    maximumFractionDigits: minimumFractionDigits,
  }).format(value);
}

export function formatDate(dateString: string): string {
  if (dateString !== '') {
    try {
      const sDate = dateString.replace("/", "-").split(' ')[0];
      if (sDate.split('-').length !== 3)
        return dateString;
      var sFormat = "dd-MM-yyyy";
      if (sDate.split('-')[0].length === 4)
        sFormat = "yyyy-MM-dd";
      const date = parse(sDate, sFormat, new Date());
      const formattedDate = format(date, 'dd-MM-yyyy');
      return formattedDate;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  } else {
    return '';
  }
}


export function formatTime(dateString: string): string {
  if (dateString !== '') {
    try {
      if (dateString.length === 5) return dateString;

      const aDate = dateString.replace("/", "-").split(' ');
      if (aDate.length === 2) {
        return aDate[1].substring(0, 5);
      }
      return dateString;
    } catch (error) {
      console.error("Error formatting time:", error);
      return "";
    }
  } else {
    return '';
  }
}

export function minutesToHHMM(minutes: number): string {
  const baseTime = startOfDay(new Date()); // 00:00 today
  const time = addMinutes(baseTime, minutes);
  return format(time, "H'H' mm'M'");
}
export function minutesToHHMM2(minutes: number): string {
  // 1. Calculate the total number of hours (can be > 24)
  const totalHours = Math.floor(minutes / 60);

  // 2. Calculate the remaining minutes (0-59)
  const remainingMinutes = minutes % 60;

  // 3. Format hours and minutes with leading zeros (e.g., 9 becomes "09")
  const formattedHours = String(totalHours).padStart(totalHours < 100 ? 2 : totalHours < 1000 ? 3 : 4, '0');
  const formattedMinutes = String(remainingMinutes).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}`;
}
export function minutes2Hours(minutes: number, decimals = 2): number {
  const hours = minutes / 60;
  return Number(hours.toFixed(decimals));
}
export function setCookie(name: string, value: string, days = 7) {
  Cookies.set(name, value, {
    expires: days, // cookie expiration in days
    path: "/",     // available on all paths
    sameSite: "strict"
  });
}

// ✅ Get a cookie
export function getCookie(name: string): string {
  return Cookies.get(name) || "";
}

// ✅ Remove a cookie
export function removeCookie(name: string) {
  Cookies.remove(name, { path: "/" });
}

// ✅ Update cookie (just call setCookie again)
export function updateCookie(name: string, value: string, days = 7) {
  setCookie(name, value, days);
}
export function getToday() {
  const today = new Date();
  return today.setHours(0, 0, 0, 0); // reset to midnight
}

export function findBreadcrumbPath(
  items: MenuItem[],
  currentHash: string,
  parents: MenuItem[] = []
): MenuItem[] | null {
  for (const item of items) {
    if (item.href === currentHash) {
      return [...parents, item]; // found exact match
    }

    if (item.items && item.items.length > 0) {
      const found = findBreadcrumbPath(item.items, currentHash, [...parents, item]);
      if (found) return found;
    }
  }
  return null;
}
export function buildBreadcrumbItems(menu: MenuItem[]) {
  const currentHash =
    (window.location.hash.startsWith('#')
      ? window.location.hash
      : `#${window.location.hash}`).split('?')[0]; // ignore query params

  const path = findBreadcrumbPath(menu, currentHash);

  // Always start with "Inicio"
  const breadcrumbs = [

    ...(path
      ? path.map(item => {
        const href = item.href && item.href.trim() !== ""
          ? item.href
          : window.location.hash;
        return { text: item.text, href };
      })
      : []),
  ];

  return breadcrumbs;
}

export function stripHtml(html: string): string {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

export function getTipoDTE(TipoDTE: number) {
  switch (TipoDTE) {
    case 33:
      return { label: "Factura Electrónica", shortLabel: "FEV", color: "blue", value: "33" };
    case 34:
      return { label: "Factura No Afecta o Exenta Electrónica", shortLabel: "FEE", color: "cyan", value: "34" };
    case 43:
      return { label: "Liquidación-Factura Electrónica", shortLabel: "LIQ", color: "purple", value: "43" };
    case 46:
      return { label: "Factura de Compra Electrónica", shortLabel: "FCE", color: "orange", value: "46" };
    case 52:
      return { label: "Guía de Despacho Electrónica", shortLabel: "GDP", color: "lightgreen", value: "52" };
    case 56:
      return { label: "Nota de Débito Electrónica", shortLabel: "NDE", color: "red", value: "56" };
    case 61:
      return { label: "Nota de Crédito Electrónica", shortLabel: "NCE", color: "green", value: "61" };
    case 110:
      return { label: "Factura de Exportación", shortLabel: "FEX", color: "blue", value: "110" };
    case 111:
      return { label: "Nota de Débito de Exportación", shortLabel: "NDE", color: "red", value: "111" };
    case 112:
      return { label: "Nota de Crédito de Exportación", shortLabel: "NCE", color: "green", value: "112" };
    case 0:
      return { label: "Desconocido", shortLabel: "Desconocido", color: "grey", value: TipoDTE.toString() };
    default:
      return { label: "Desconocido", shortLabel: "Desconocido", color: "grey", value: TipoDTE.toString() };
  }
}

export function base64Encode(str: any) {
  try {
    // 1. Convert the string to a sequence of bytes (Uint8Array)
    const bytes = new TextEncoder().encode(str);
    // 2. Convert the byte sequence to a binary string
    const binary = String.fromCodePoint(...bytes);
    // 3. Encode the binary string to Base64
    return btoa(binary);
  } catch (e) {
    console.error("Encoding failed:", e);
    return '';
  }
};

export function base64Decode(b64: string): string {
  try {
    const binary = atob(b64);

    // Convert binary string to a Uint8Array of byte codes
    const bytes = Uint8Array.from(binary, c => c.codePointAt(0) || 0);

    // Decode the bytes back to a regular string
    const decodedString = new TextDecoder().decode(bytes); // ⬅️ The final result

    return decodedString; // ⬅️ RETURN ADDED HERE

  } catch (e) {
    console.error("Decoding failed:", e);
    return ''; // Return an empty string on error
  }
};

export function exportToExcel(data: any, name: string = "export.xls", sheet: string = "Hoja 1") {
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheet);
    XLSX.writeFile(wb, `${name}.xlsx`);
  };
  exportToExcel();
}

export function isMobileDevice() {
  if (typeof window !== 'undefined') {
    // Se utiliza 'navigator.userAgent' y 'navigator.vendor' que son tipados.
    // Para 'window.opera', se accede a través de 'window as any' para evitar el error de TS,
    // ya que no es una propiedad estándar del objeto Window.
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // 1. Detección de dispositivos Android, iOS y Windows Phone
    if (/android/i.test(userAgent)) {
      return true;
    }

    // 2. Detección de iOS (iPad, iPhone, iPod)
    // Se corrige el error de tipado accediendo a window.MSStream con 'window as any'.
    // Nota: A partir de iOS 13, iPad puede reportar un User-Agent de escritorio 
    // pero mantiene un toque táctil. 'MacIntel' y 'maxTouchPoints' es la forma moderna de detectar iPads.
    if (/iPad|iPhone|iPod/.test(userAgent) && !((window as any).MSStream)) {
      return true;
    }

    // 3. Detección general de sistemas operativos móviles (BlackBerry, Windows Phone, etc.)
    if (/Mobi|Tablet|Mobile|Windows Phone|IEMobile|BlackBerry|Opera Mini/i.test(userAgent)) {
      return true;
    }

    // 4. Detección moderna para tablets (como iPad en modo escritorio)
    // Verifica si el dispositivo es macOS/Intel pero tiene capacidad táctil
    if (
      navigator.platform === 'MacIntel' &&
      typeof navigator.maxTouchPoints === 'number' &&
      navigator.maxTouchPoints > 2
    ) {
      return true;
    }
  }
  return false;
}


export const resizeBase64Image = (
  base64: string,
  maxSize: number,
  quality: number = 0.7
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;

      // Determine which side is larger
      const isWidthLarger = width >= height;

      // Compute proportional dimensions
      let targetWidth: number;
      let targetHeight: number;

      if (isWidthLarger) {
        const ratio = maxSize / width;
        targetWidth = maxSize;
        targetHeight = height * ratio;
      } else {
        const ratio = maxSize / height;
        targetHeight = maxSize;
        targetWidth = width * ratio;
      }

      const canvas = document.createElement("canvas");
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      const ctx = canvas.getContext("2d");
      if (!ctx) return reject("Canvas not supported");

      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

      resolve(canvas.toDataURL("image/jpeg", quality));
    };

    img.onerror = reject;
    img.src = base64;
  });
};
function generateRandomLettersString(N: number): string {
  // Define the characters (A-Z and a-z)
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';

  // Get the length of the character set
  const charactersLength = characters.length;

  for (let i = 0; i < N; i++) {
    // Generate a random index within the length of the character set
    const randomIndex = Math.floor(Math.random() * charactersLength);

    // Append the character at the random index to the result
    result += characters.charAt(randomIndex);
  }

  return result;
}

export async function downloadFile(url: string, filename: string) {
  console.time(`Download-Time-${filename}`); // Optional: starts a timer

  try {
    if (url.includes("store.planeadores.cl")) {
      url = `${getUrlVersion()}/resources/images/aws?url=${url}&filename=${encodeURIComponent(filename)}`;
    }

    const response = await fetch(url, { mode: "cors", cache: "no-store" });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);

  } catch (error) {
    console.error(`❌ Download failed for ${filename}:`, error);
  } finally {
    console.timeEnd(`Download-Time-${filename}`); // Stops timer and logs duration
  }
}

export function addNotification(
  content: string,
  type: "info" | "success" | "warning" | "error" = "info",
  setData: (callback: (prevData: any) => any) => void
) {
  if (!content || content == "") return;
  scrollToTop();

  const duration = 10000; // 10 seconds
  const id = Date.now().toString() + Math.random().toString(36).substring(2, 7);
  const expiresAt = Date.now() + duration; // Calculate the end time

  const rawNotification = { id, content, type, expiresAt };

  setData((prevData: any) => {
    const currentNotifications = type === "error" ? [] : (prevData?.flashbar || []);
    const newData = {
      ...prevData,
      flashbar: [rawNotification, ...currentNotifications].slice(0, 5)
    };
    localStorage.setItem("data", JSON.stringify(newData));
    return newData;
  });

  // Automatic removal
  setTimeout(() => {
    setData((prevData: any) => {
      const updatedNotifications = (prevData?.flashbar || []).filter((n: any) => n.id !== id);
      const updatedData = { ...prevData, flashbar: updatedNotifications };
      localStorage.setItem("data", JSON.stringify(updatedData));
      return updatedData;
    });
  }, duration);
}


export function formatTowType(type: string) {
  if (type === "NONE") return "Autodespegue";
  if (type === "BALLAST") return "Lastre";
  if (type === "MOUNTAIN") return "Cordillera";
  if (type === "LOCAL") return "Local";
  if (type === "SANRAMON") return "San Ramón";
  if (type === "TOTALS") return "TOTALES";
  return type; // Returns the Pilot's Display Name or original string if no match
};
export function addNotificationStatus(
  data: any,
  setData: (callback: (prevData: any) => any) => void
) {
  if (!data || !data.status || data.status === "" || data.code == null) return;



  const duration = 10000; // 10 seconds
  const id = Date.now().toString() + Math.random().toString(36).substring(2, 7);
  const expiresAt = Date.now() + duration; // Calculate the end time
  const type = data.code === 0 ? "info" : "error";
  const content: string = data.status;
  const rawNotification = { id, content, type, expiresAt };
  setData((prevData: any) => {
    const currentNotifications = type === "error" ? [] : (prevData?.flashbar || []);
    const newData = {
      ...prevData,
      flashbar: [rawNotification, ...currentNotifications].slice(0, 5)
    };
    localStorage.setItem("data", JSON.stringify(newData));

    return newData;
  });
  // Automatic removal
  setTimeout(() => {
    setData((prevData: any) => {
      const updatedNotifications = (prevData?.flashbar || []).filter((n: any) => n.id !== id);
      const updatedData = { ...prevData, flashbar: updatedNotifications };
      localStorage.setItem("data", JSON.stringify(updatedData));
      return updatedData;
    });
  }, duration);
  scrollToTop();
}

export function clearNotifications(
  setData: (callback: (prevData: any) => any) => void
) {
  //130008835-6 CpvCma2026
  setData((prevData: any) => {
    const newData = {
      ...prevData,
      flashbar: [] // Reset to empty array
    };

    // Sync with localStorage so they don't reappear on refresh
    localStorage.setItem("data", JSON.stringify(newData));

    return newData;
  });
}
export function getUrlVersion() {
  if (window.location.host.includes("app.planeadores.cl"))
    return "https://app.planeadores.cl";
  if (window.location.host.includes("[::1]:") || window.location.host.includes("localhost") || window.location.host.startsWith("192.168.")) {
    if (true)
      return "http://app3.planeadores.cl";
    else
      return "http://localhost:5100";
  }
  //  return "http://app3.planeadores.cl";
  //return "http://localhost:5100";

  let url = window.location.protocol + "//" + window.location.host;
  return url;
  /*
  if (window.location.host.includes("localhost") || window.location.host.includes("[::1]"))
    return "https://app2.planeadores.cl";
  else 
  else
    return "https://app2.planeadores.cl";
  */

}
export function scrollToTop() {
  window.scrollTo({ top: 0 });
}

export function sanitizeKeyw(str: string) {
  try {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
  } catch (e) {
    return str;
  }
}

export function saveMasters(masters: any, dataTemp: any) {
  if (masters && dataTemp) {
    if (masters.checks) { dataTemp.checks = masters.checks; }
    if (masters.accountPlans) { dataTemp.accountPlans = masters.accountPlans; }
    if (masters.bookingTypes) { dataTemp.bookingTypes = masters.bookingTypes; }
    if (masters.categories) { dataTemp.categories = masters.categories; }
    if (masters.charges) { dataTemp.charges = masters.charges; }
    if (masters.groupTypes) { dataTemp.groupTypes = masters.groupTypes; }
    if (masters.groups) { dataTemp.groups = masters.groups; }
    if (masters.usersStatuses) { dataTemp.usersStatuses = masters.usersStatuses; }
    if (masters.usersTypes) { dataTemp.usersTypes = masters.usersTypes; }
    if (masters.equipments) { dataTemp.equipments = masters.equipments; }
    if (masters.makes) { dataTemp.makes = masters.makes; }
    if (masters.users) { dataTemp.users = masters.users; }
    if (masters.complaintCategories) { dataTemp.complaintCategories = masters.complaintCategories; }
    if (masters.complaintTypes) { dataTemp.complaintTypes = masters.complaintTypes; }
    if (masters.countries) { dataTemp.countries = masters.countries; }

    localStorage.setItem("data", JSON.stringify(dataTemp))
    setData(dataTemp)
    return dataTemp;
  }
}

const cl_banco_itau = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" class="w-8 h-8 rounded-[3px]"><rect width="32" height="32" fill="#FF6200" rx="3"></rect><path fill="#FF6200" d="M13.914.02c-.921.022-1.597.055-2.836.13a44.407 44.407 0 0 0-2.152.18A42.196 42.196 0 0 0 6.08.712c-.088.016-.237.044-.332.06a23.213 23.213 0 0 0-1.569.332l-.21.049c-.59.14-1.176.424-1.626.792-.439.356-.83.931-1.028 1.502-.032.089-.064.18-.074.202-.034.076-.183.72-.29 1.247-.016.088-.044.219-.06.291a7.002 7.002 0 0 0-.052.282A2.971 2.971 0 0 1 .8 5.69c-.03.115-.153.9-.231 1.468-.077.551-.127.952-.171 1.358l-.048.432c-.006.039-.024.234-.043.433-.016.199-.04.442-.052.543-.042.37-.147 1.981-.199 3.118-.04.842-.066 2.646-.052 3.63.014 1.227.044 2.323.072 2.705.01.155.03.481.042.724.012.244.029.555.039.694.046.696.082 1.153.1 1.297.01.09.034.324.05.521a21.122 21.122 0 0 0 .1.958c.051.477.09.788.122.996.016.11.044.3.06.422.058.442.127.873.201 1.267l.06.332c.035.201.113.601.17.855.193.887.277 1.152.504 1.589.063.12.143.261.18.311l.11.161c.115.171.443.505.624.634.03.022.088.064.126.094.04.032.079.057.089.057.008 0 .028.014.044.03.078.076.632.34.869.41.044.014.098.032.12.043.053.024.348.098.705.179l.351.084c.093.024.676.14 1.117.221.253.046.746.125 1.056.17.116.015.265.037.332.05.243.042 1.249.158 1.88.219l.624.06a41.243 41.243 0 0 0 2.011.143l.774.04c1.432.082 5.528.082 6.94 0 .177-.012.524-.028.774-.04a59.937 59.937 0 0 0 3.811-.33c.123-.018.334-.046.473-.064a36.276 36.276 0 0 0 1.62-.248c.44-.08 1.023-.197 1.116-.221.038-.01.196-.048.352-.084.347-.079.65-.155.703-.18l.202-.07c.164-.054.712-.314.758-.358a.587.587 0 0 1 .088-.064c.157-.099.23-.155.373-.284.16-.147.384-.388.438-.47.018-.029.066-.097.106-.151a.664.664 0 0 0 .077-.115c0-.008.032-.064.07-.125.039-.06.085-.149.103-.197.02-.046.04-.096.048-.106.038-.05.18-.451.24-.678.094-.352.271-1.183.335-1.575.017-.1.035-.195.04-.211.019-.045.13-.735.23-1.438.022-.155.044-.31.05-.342.016-.093.089-.71.121-1.036.016-.161.038-.346.05-.413.012-.066.034-.283.05-.482.017-.2.039-.445.049-.543.012-.1.03-.33.042-.513.012-.183.03-.408.04-.503.012-.095.034-.443.05-.774.019-.332.039-.74.05-.905.091-1.463.091-5.3 0-6.809l-.04-.744c-.012-.237-.03-.551-.04-.694-.012-.145-.038-.5-.06-.794-.022-.294-.044-.57-.05-.614-.006-.044-.024-.24-.04-.432a7.624 7.624 0 0 0-.04-.403 11.188 11.188 0 0 1-.051-.412 28.132 28.132 0 0 0-.181-1.428 33.815 33.815 0 0 0-.519-2.876 5.368 5.368 0 0 0-.145-.563 5.286 5.286 0 0 0-.366-.845l-.14-.211a3.982 3.982 0 0 0-.729-.759c-.434-.32-.917-.537-1.54-.69a29.646 29.646 0 0 1-.322-.08 9.323 9.323 0 0 0-.543-.12l-.272-.06C26.47.79 25.206.586 24.383.482a7.154 7.154 0 0 1-.362-.05c-.06-.013-.352-.043-.945-.101-.165-.016-.392-.04-.503-.05-.11-.012-.31-.03-.442-.043L21.648.2c-.45-.038-1.702-.11-2.394-.14a96.87 96.87 0 0 0-5.34-.039ZM5.052 13.61a.55.55 0 0 0 .129.043c.109.026.262.097.376.173.09.06.304.29.346.37.02.04.042.077.048.083a.454.454 0 0 1 .04.09.39.39 0 0 0 .043.1c.026.039.056.278.056.455 0 .173-.026.376-.06.45-.109.25-.161.332-.298.477a.99.99 0 0 1-.352.256.982.982 0 0 1-.322.114.375.375 0 0 0-.127.03c-.014.025-.45.025-.45 0 0-.007-.05-.022-.115-.03a.847.847 0 0 1-.175-.04 2.07 2.07 0 0 0-.132-.054.404.404 0 0 1-.08-.036.282.282 0 0 0-.071-.043c-.117-.058-.358-.325-.429-.472-.038-.079-.074-.155-.084-.171-.068-.137-.08-.76-.016-.905.018-.039.044-.103.058-.141a.404.404 0 0 1 .036-.08.667.667 0 0 0 .053-.09c.038-.076.277-.333.311-.333.008 0 .027-.014.04-.032.039-.042.234-.137.353-.167.056-.014.118-.034.14-.044a.594.594 0 0 1 .121-.026c.119-.012.535.006.561.024m21.916 1.403v1.015h-3.902v-1.36l.217-.034c.48-.074.78-.124.799-.136.012-.008.11-.024.22-.038a1.23 1.23 0 0 0 .222-.04c.012-.009.107-.027.211-.041a2.7 2.7 0 0 0 .302-.052c.06-.014.187-.036.281-.048.095-.013.19-.03.212-.039.022-.01.122-.028.22-.042.102-.012.214-.03.252-.042.038-.01.183-.038.322-.06l.402-.067c.083-.016.171-.028.197-.03l.045-.002v1.016Zm-16.654.897v1.204h2.011v1.79h-2.013l.008 1.865c.006 2.01.002 1.91.11 2.158a.853.853 0 0 0 .517.435.286.286 0 0 1 .09.036c.037.03.852.03.888-.002a.531.531 0 0 1 .165-.036l.135-.014v1.764l-.055.024c-.05.022-.281.058-.599.096-.452.053-1.277.059-1.326.008a.14.14 0 0 0-.074-.018 2.29 2.29 0 0 1-.428-.078.51.51 0 0 0-.123-.04.692.692 0 0 1-.12-.04.39.39 0 0 0-.101-.043.391.391 0 0 1-.09-.038.779.779 0 0 0-.081-.05 1.414 1.414 0 0 1-.306-.196.537.537 0 0 0-.11-.078c-.02-.002-.174-.169-.294-.322a2.49 2.49 0 0 1-.276-.463.478.478 0 0 0-.04-.08.643.643 0 0 1-.048-.14 1.454 1.454 0 0 0-.053-.172 1.333 1.333 0 0 1-.05-.2 9.596 9.596 0 0 0-.054-.252c-.014-.06-.024-.769-.03-2.108l-.008-2.015H6.794v-1.79h1.167v-2.028l.136-.014a.615.615 0 0 0 .155-.03c.012-.008.11-.026.222-.04a1.19 1.19 0 0 0 .22-.043c.013-.008.14-.03.282-.048a2.04 2.04 0 0 0 .282-.05.55.55 0 0 1 .15-.028c.095-.012.19-.027.282-.046.216-.045.592-.103.61-.093.008.004.014.551.014 1.215Zm6.668 1.013c.281.016.599.053.623.07.012.009.06.023.11.029.115.018.395.1.564.169a3.785 3.785 0 0 1 .583.302c.028.014.117.084.195.153.079.07.151.13.161.134.03.014.388.449.388.473a3.873 3.873 0 0 1 .262.5c0 .007.016.051.038.097.02.047.044.117.052.155a.357.357 0 0 0 .03.09c.008.01.027.075.04.141.013.067.029.135.035.151.008.016.026.103.042.191.024.133.03.634.038 2.85l.008 2.692h-2.194l-.002-.238a7.972 7.972 0 0 0-.016-.414l-.012-.181-.059.08a3.395 3.395 0 0 1-.516.493c-.264.173-.334.215-.407.24a.684.684 0 0 0-.13.052.904.904 0 0 1-.165.05.655.655 0 0 0-.131.04c-.103.077-1.37.075-1.469-.002a.78.78 0 0 0-.16-.04 1.11 1.11 0 0 1-.202-.052 8.232 8.232 0 0 0-.188-.079 2.835 2.835 0 0 1-.4-.21c-.085-.047-.114-.073-.343-.303-.235-.235-.265-.267-.265-.29a.538.538 0 0 0-.056-.098 1.353 1.353 0 0 1-.103-.185 3.138 3.138 0 0 0-.07-.15.802.802 0 0 1-.053-.162.639.639 0 0 0-.04-.13c-.022-.029-.06-.314-.06-.439 0-.058-.01-.116-.022-.128-.025-.025-.019-.105.044-.59a.891.891 0 0 1 .038-.19.532.532 0 0 0 .038-.12c.026-.104.08-.24.137-.344a6.96 6.96 0 0 0 .054-.104c.012-.026.029-.046.038-.046.008 0 .015-.012.015-.026 0-.023.22-.31.259-.336a.108.108 0 0 0 .028-.047.086.086 0 0 1 .054-.048c.023-.006.04-.018.04-.026 0-.02.339-.286.453-.352.083-.05.268-.145.537-.274.039-.02.415-.14.58-.187.06-.018.179-.042.261-.054a.967.967 0 0 0 .171-.038c.012-.008.133-.026.272-.038.138-.012.31-.032.382-.043.285-.042 1.289-.034 1.396.01.036.016.038.009.024-.163a.731.731 0 0 0-.03-.189c-.01-.006-.023-.044-.03-.084a1.314 1.314 0 0 0-.163-.348c-.047-.07-.242-.272-.264-.272a.28.28 0 0 1-.077-.046.946.946 0 0 0-.317-.145c-.043-.008-.077-.022-.077-.03 0-.088-1.299-.102-1.69-.016-.05.01-.166.032-.26.048a1.39 1.39 0 0 0-.212.049 1.01 1.01 0 0 1-.16.04c-.067.012-.14.03-.162.04-.022.01-.102.032-.179.05a.803.803 0 0 0-.16.049.597.597 0 0 1-.123.042.578.578 0 0 0-.121.042.658.658 0 0 1-.12.04.894.894 0 0 0-.176.06.471.471 0 0 1-.086.039c-.006 0-.01-.42-.01-.933 0-.726.006-.938.026-.954a.475.475 0 0 1 .125-.046.483.483 0 0 0 .12-.038.827.827 0 0 1 .151-.05.962.962 0 0 0 .151-.05.583.583 0 0 1 .139-.04.79.79 0 0 0 .15-.043c.019-.008.101-.03.184-.048.064-.013.128-.027.19-.043.023-.006.135-.024.252-.04.117-.016.24-.038.272-.048.116-.036 1.17-.103 1.408-.089l.322.018M5.889 21.117v4.003H3.536v-8.006h2.353v4.003m17.78-1.509c0 2.382.01 2.843.059 2.907.01.01.022.05.03.089.028.15.159.37.307.518.079.08.167.151.195.16.03.005.053.017.053.026 0 .007.07.036.157.064.128.04.197.048.398.048.14 0 .263-.01.292-.022a.901.901 0 0 1 .138-.048.85.85 0 0 0 .201-.097c.113-.072.322-.265.322-.298 0-.01.029-.054.06-.096a.34.34 0 0 0 .061-.1c0-.013.018-.055.038-.095a.618.618 0 0 0 .054-.151.241.241 0 0 1 .03-.099c.051-.064.06-.47.06-2.83v-2.47h2.352v8.006h-1.114c-.87 0-1.12-.006-1.132-.026a3.483 3.483 0 0 1-.022-.423 2.75 2.75 0 0 0-.022-.396c-.008 0-.033.024-.057.054-.113.153-.29.326-.567.555-.04.032-.123.077-.304.165l-.2.1a.954.954 0 0 1-.172.051.463.463 0 0 0-.13.04c-.02.03-.377.06-.729.06-.346 0-.627-.023-.71-.058a1.474 1.474 0 0 0-.17-.052.807.807 0 0 1-.152-.05.493.493 0 0 0-.104-.043c-.048-.012-.087-.03-.087-.038s-.036-.026-.08-.04c-.044-.014-.08-.032-.08-.04s-.023-.024-.049-.036c-.173-.079-.565-.447-.73-.684a2.936 2.936 0 0 1-.288-.541 1.342 1.342 0 0 0-.05-.137 1.196 1.196 0 0 1-.05-.161.747.747 0 0 0-.04-.135 1.1 1.1 0 0 1-.04-.21 1.004 1.004 0 0 0-.047-.218c-.018-.03-.026-.748-.03-2.893l-.006-2.85h2.355v2.494"></path><path fill="#fff" d="M5.053 13.61c.012.01.07.029.129.043.108.026.261.097.376.173.09.06.304.29.346.37.02.04.042.076.048.082a.453.453 0 0 1 .04.091.39.39 0 0 0 .043.1c.026.039.056.278.056.455 0 .173-.026.376-.06.45-.11.25-.162.332-.298.477a.99.99 0 0 1-.352.256.986.986 0 0 1-.322.114.373.373 0 0 0-.127.03c-.014.025-.45.025-.45 0 0-.008-.05-.022-.115-.03a.856.856 0 0 1-.175-.04 2.073 2.073 0 0 0-.133-.054.412.412 0 0 1-.08-.036.28.28 0 0 0-.07-.043c-.117-.058-.359-.326-.429-.472-.038-.079-.074-.155-.084-.171-.069-.137-.08-.76-.017-.905.019-.039.045-.103.059-.141a.413.413 0 0 1 .036-.08.659.659 0 0 0 .052-.091c.039-.075.278-.332.312-.332.008 0 .026-.014.04-.032.038-.042.234-.137.352-.167.057-.014.119-.034.141-.044a.584.584 0 0 1 .12-.027c.12-.012.536.006.562.025m21.915 1.402v1.016h-3.902v-1.36l.218-.034c.48-.074.78-.124.798-.136a1.37 1.37 0 0 1 .221-.038c.11-.015.212-.033.222-.04.012-.009.106-.027.21-.041.105-.012.242-.036.303-.052.06-.014.187-.037.281-.049.095-.012.19-.03.211-.038.023-.01.123-.028.222-.042a2 2 0 0 0 .251-.042c.038-.01.183-.038.322-.06l.402-.067c.083-.016.171-.028.197-.03l.044-.002v1.015m-16.653.898v1.204h2.01v1.79h-2.012l.008 1.865c.006 2.01.002 1.91.11 2.158a.853.853 0 0 0 .517.435.285.285 0 0 1 .089.036c.038.03.853.03.889-.002a.529.529 0 0 1 .165-.036l.134-.014v1.764l-.054.024c-.05.022-.281.058-.6.096-.452.053-1.277.059-1.325.008a.14.14 0 0 0-.074-.018 2.29 2.29 0 0 1-.429-.078.522.522 0 0 0-.122-.04.707.707 0 0 1-.121-.04.381.381 0 0 0-.1-.043.396.396 0 0 1-.091-.038.829.829 0 0 0-.08-.05 1.41 1.41 0 0 1-.306-.196.534.534 0 0 0-.11-.078c-.021-.002-.174-.17-.294-.322a2.499 2.499 0 0 1-.276-.463.472.472 0 0 0-.04-.08.644.644 0 0 1-.049-.14 1.462 1.462 0 0 0-.052-.172 1.328 1.328 0 0 1-.05-.2 9.705 9.705 0 0 0-.055-.252c-.014-.06-.024-.769-.03-2.108l-.008-2.015H6.795v-1.79H7.96v-2.028l.137-.014a.606.606 0 0 0 .155-.03c.012-.008.11-.026.221-.04.11-.014.212-.035.221-.043.012-.008.14-.03.282-.048.145-.02.272-.042.282-.05a.548.548 0 0 1 .15-.028c.095-.012.189-.027.282-.047.215-.044.591-.102.61-.092.008.004.014.551.014 1.215m6.667 1.013c.282.016.6.053.624.07.012.009.06.023.11.029.115.018.395.1.563.169a3.821 3.821 0 0 1 .584.302c.028.014.117.084.195.153.078.07.15.13.16.134.031.014.389.449.389.473a3.862 3.862 0 0 1 .262.5c0 .007.016.051.038.097.02.046.044.117.052.155a.364.364 0 0 0 .03.09c.008.01.026.075.04.141.012.067.029.135.035.151.008.016.026.103.042.191.024.133.03.634.038 2.85l.008 2.692h-2.194l-.002-.238a8.122 8.122 0 0 0-.016-.414l-.012-.181-.059.08a3.402 3.402 0 0 1-.517.493c-.263.173-.334.215-.406.24a.693.693 0 0 0-.13.052.901.901 0 0 1-.166.05.662.662 0 0 0-.13.04c-.103.077-1.37.075-1.469-.002a.768.768 0 0 0-.16-.04 1.11 1.11 0 0 1-.202-.052 8.334 8.334 0 0 0-.189-.079 2.833 2.833 0 0 1-.4-.21c-.085-.047-.113-.073-.342-.303-.235-.235-.266-.267-.266-.29a.533.533 0 0 0-.056-.098 1.353 1.353 0 0 1-.103-.185 3.236 3.236 0 0 0-.07-.15.803.803 0 0 1-.052-.162.639.639 0 0 0-.04-.13c-.022-.029-.06-.314-.06-.439 0-.058-.01-.116-.023-.128-.024-.025-.018-.105.044-.59a.888.888 0 0 1 .039-.19.538.538 0 0 0 .038-.12c.026-.104.08-.24.137-.344a9.56 9.56 0 0 0 .054-.104c.012-.026.028-.046.038-.046.008 0 .014-.012.014-.026 0-.023.221-.31.26-.336a.106.106 0 0 0 .028-.047.085.085 0 0 1 .054-.048c.022-.006.04-.018.04-.026 0-.02.338-.286.453-.352.082-.05.268-.145.537-.274.038-.02.414-.14.58-.187.06-.018.178-.042.26-.054a.972.972 0 0 0 .172-.038c.012-.008.132-.026.271-.038.14-.012.31-.032.382-.043.286-.042 1.29-.034 1.396.01.037.016.038.009.024-.163a.725.725 0 0 0-.03-.189c-.01-.006-.022-.044-.03-.084a1.312 1.312 0 0 0-.163-.348c-.046-.07-.241-.272-.264-.272a.282.282 0 0 1-.076-.046.947.947 0 0 0-.318-.145c-.042-.008-.076-.022-.076-.03 0-.088-1.3-.102-1.69-.016-.05.01-.166.032-.26.048-.096.016-.19.038-.212.049-.022.01-.095.028-.161.04s-.139.03-.161.04c-.022.01-.103.032-.179.05a.794.794 0 0 0-.16.049.583.583 0 0 1-.124.042.583.583 0 0 0-.12.042.659.659 0 0 1-.121.04.883.883 0 0 0-.175.06.477.477 0 0 1-.086.039c-.007 0-.01-.42-.01-.933 0-.727.006-.938.026-.954a.466.466 0 0 1 .124-.046.478.478 0 0 0 .121-.038.838.838 0 0 1 .151-.05.953.953 0 0 0 .15-.05.58.58 0 0 1 .14-.04.808.808 0 0 0 .15-.043c.019-.008.101-.03.183-.048a3.82 3.82 0 0 1 .442-.083c.118-.016.24-.038.272-.048.117-.036 1.171-.103 1.408-.089l.322.018M5.89 21.117v4.003H3.536v-8.006H5.89v4.003m17.78-1.509c0 2.382.01 2.843.058 2.907.01.01.022.05.03.088.029.151.16.37.308.52.078.08.167.15.195.158.03.006.053.018.053.026s.07.036.156.065c.13.04.198.048.399.048.14 0 .263-.01.291-.022a.912.912 0 0 1 .139-.048.846.846 0 0 0 .201-.097c.113-.072.322-.265.322-.298 0-.01.028-.054.06-.096a.337.337 0 0 0 .06-.1.4.4 0 0 1 .039-.095.615.615 0 0 0 .054-.151.243.243 0 0 1 .03-.099c.05-.064.059-.47.059-2.83v-2.47h2.353v8.006h-1.114c-.871 0-1.12-.006-1.133-.027a3.482 3.482 0 0 1-.022-.422 2.753 2.753 0 0 0-.022-.396c-.008 0-.032.024-.056.054-.113.153-.29.326-.567.555-.04.032-.123.077-.304.165-.083.04-.173.087-.201.1a.957.957 0 0 1-.171.051.47.47 0 0 0-.131.04c-.02.03-.376.06-.728.06-.346 0-.628-.024-.71-.058a1.474 1.474 0 0 0-.171-.052.797.797 0 0 1-.15-.05.5.5 0 0 0-.105-.043c-.049-.012-.087-.03-.087-.038s-.036-.026-.08-.04c-.045-.014-.08-.032-.08-.04s-.023-.024-.05-.036c-.172-.079-.564-.447-.73-.684a2.922 2.922 0 0 1-.287-.541 1.296 1.296 0 0 0-.05-.137 1.229 1.229 0 0 1-.05-.161.746.746 0 0 0-.04-.135 1.107 1.107 0 0 1-.04-.211.992.992 0 0 0-.047-.217c-.018-.03-.026-.748-.03-2.893l-.006-2.85h2.355v2.494Z"></path><path fill="#FF6200" d="M16.72 21.562c-.098.01-.199.026-.221.036a.886.886 0 0 1-.16.044 1.06 1.06 0 0 0-.192.054c-.302.131-.449.218-.549.322a.89.89 0 0 0-.21.404.389.389 0 0 1-.03.115c-.022.046-.014.19.023.376.04.203.201.45.343.525.254.13.302.15.443.173.253.038.736.016.841-.04a3.57 3.57 0 0 1 .165-.077c.072-.034.167-.088.211-.122l.113-.089c.114-.086.326-.436.354-.58a.269.269 0 0 1 .034-.096c.014-.018.024-.203.028-.535l.008-.506-.109-.012c-.147-.019-.87-.012-1.092.008"></path></svg>`;
const cl_banco_estado = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" class="w-8 h-8 rounded-[3px]"><g fill-rule="evenodd" clip-rule="evenodd"><path fill="#CD223F" d="m-.001 16.058 11.356-4.934v-3.67c3.557-.573 6.883-2.409 9.176-5.163L32 11.583V-.002H-.001v16.06"></path><path fill="#FFFFFE" d="M11.47 26.609h9.176V2.29c-2.295 2.754-5.621 4.59-9.176 5.163v3.67L-.001 16.057v3.555l11.47-5.047v-3.441l3.556-1.606v3.557L11.47 14.68v3.44l3.67-1.606v3.442l-3.67 1.72v-3.44L-.001 23.168v3.44l11.47-5.047v5.047"></path><path fill="#E87D34" d="M11.355 18.12v-3.439L-.001 19.613v3.557l11.356-5.05M11.355 21.675-.001 26.607h11.356v-4.932M11.35 14.68l3.67-1.605V9.518l-3.67 1.605v3.557"></path><path fill="#E87D34" d="M11.35 18.12v3.558l3.67-1.606v-3.557l-3.67 1.606"></path><path fill="#E67C35" d="M20.645 26.609h11.356V11.698L20.53 2.29l.115 24.318"></path><path fill="#E46B32" d="M20.53 26.609h.115L20.53 2.29V26.61"></path><path fill="#005899" d="M20.646 26.609H0v5.39h32.003v-5.39H20.646"></path></g></svg>`;
const cl_banco_bci = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" class="w-8 h-8 rounded-[3px]"><path fill="#fff" d="M0 0h32v32H0z"></path><path fill="#188C44" fill-rule="evenodd" d="M20.53 18.194s3.042.812 2.083 5.085a2.029 2.029 0 0 0-.04.709c.103 1.27 1.208 2.187 2.48 2.083a2.279 2.279 0 0 0 2.083-2.48c-.209-2.98-5.814-6.606-6.564-6.522 0 0-.438.02-.46.582 0 .46.419.543.419.543" clip-rule="evenodd"></path><path fill="#F9D339" fill-rule="evenodd" d="M19.591 19.61s1.98.521 1.377 3.315c0 0-.647 2.625-4.856 3.333-4.773.792-4.69-.958-4.69-.958-.04-.875-.374-1.917 4.357-4.793 0 0 2.375-1.459 3.812-.897" clip-rule="evenodd"></path><path fill="#DB3942" fill-rule="evenodd" d="M3.692 26.758a2.81 2.81 0 0 0 2.375 2.688c.189.02.376.04.563.04a2.78 2.78 0 0 0 1.958-.895 2.808 2.808 0 0 0 .751-2.02c0-2.043.918-3.565 2.772-4.982 1.668-1.229 4.063-2.729 7.419-4.605 4.188-2.23 6.897-4.855 7.5-6.982l.023-.061c.083-.272.104-.543.083-.814A2.81 2.81 0 0 0 24.76 6.44a5.173 5.173 0 0 0-.562-.04 2.812 2.812 0 0 0-2.71 2.917c0 2.145-1.291 3.562-3.043 5.23-3.73 2.917-7.167 4.355-7.167 4.355-4.19 2.23-6.898 4.855-7.503 6.982l-.02.061c-.042.27-.084.542-.063.814" clip-rule="evenodd"></path><path fill="#3366A1" fill-rule="evenodd" d="M8.13 6.67c.23 3.791 5.48 8.19 8.732 9.96.875.479 1.96.605 2.417.459 1.48-.668-.104-1.25-.104-1.25s-5.105-1.396-3.459-8.586c.083-.376.124-.77.104-1.188-.167-2.104-2.021-3.689-4.147-3.543A3.868 3.868 0 0 0 8.13 6.67Z" clip-rule="evenodd"></path><rect width="31" height="31" x=".5" y=".5" stroke="#DDE0E2" rx="2.5"></rect></svg>`;
const cl_banco_falabella = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" class="w-8 h-8 rounded-[3px]"><rect width="31" height="31" x=".5" y=".5" fill="#fff" rx="2.5"></rect><rect width="31" height="31" x=".5" y=".5" stroke="#DDE0E2" rx="2.5"></rect><path fill="#1C874E" fill-rule="evenodd" d="M19.918 27.496c-3.96 0-15.428-3.206-15.428-7.17 0-3.953 11.467-7.164 15.428-7.164a7.167 7.167 0 0 1 0 14.334" clip-rule="evenodd"></path><path fill="#ACCD53" fill-rule="evenodd" d="M16.386 15.855c-2.578-1.562-8.772-8.185-7.208-10.76C10.741 2.52 19.474 4.96 22.051 6.53a5.454 5.454 0 0 1 1.832 7.496 5.453 5.453 0 0 1-7.497 1.83" clip-rule="evenodd"></path><path fill="#014F2A" d="M19.919 13.17a7.13 7.13 0 0 1 3.811 1.1 5.453 5.453 0 0 1-7.344 1.593c-.582-.353-1.348-.965-2.168-1.73 2.263-.612 4.392-.963 5.7-.963"></path></svg>`;
const cl_banco_de_chile = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" class="w-8 h-8 rounded-[3px]"><rect width="32" height="32" fill="#0F2B5F" rx="3"></rect><g fill="#F5F5F5" fill-rule="evenodd" clip-rule="evenodd"><path d="M12.676 7.87c-1.174 1.42-3.228 2.225-4.318 3.837v8.906c0 1.332-.86 1.028-.779 1.825l4.754-3.444V9.722l6.159-4.913-.317-.155c-1.593.723-3.215-.781-5.051-.645-2.711.107-5.106 1.389-6.901 3.369 1.86-.914 4.83-1.108 6.453.492"></path><path d="M20.073 14.116V9.274c1.287 1.007 2.47 4.146 0 4.842m.472 10.203-.472-.299v-7.486c.523.017.848.707.83 1.387 0 0 .04 5.277.04 5.771 0 .493-.398.627-.398.627m.589-9.205c1.376-1.1 3.114-2.036 4.118-3.65.916-1.562-1.65-4.712-2.965-6.97l-1.135-.326-7.75 6.15v10.477c0 1.27-.611.908-.579 1.612l4.902-3.627V8.424L19.03 7.35v16.218l-2.635-.757c-3.657-.504-7.023 1.325-9.105 4.17 3.368-1.734 7.807-1.304 10.892 1.02l6.776-5.304c1.08-1.132.435-3.185.471-4.637-.2-2.434-2.7-2.593-4.295-2.946"></path></g></svg>`;
const cl_banco_santander = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" class="w-8 h-8 rounded-[3px]"><path fill="#EA1D25" d="M0 0h32v32H0z"></path><path fill="#fff" d="M21.455 15.063c-.057-.853-.284-1.705-.74-2.444l-3.863-6.762a5.8 5.8 0 0 1-.625-1.648l-.17.285a5.39 5.39 0 0 0 0 5.398l3.125 5.398a5.39 5.39 0 0 1 0 5.398l-.17.284a5.803 5.803 0 0 0-.626-1.648l-2.84-4.943-1.82-3.182a5.799 5.799 0 0 1-.624-1.648l-.17.284c-.967 1.648-.967 3.693 0 5.398l3.124 5.398a5.39 5.39 0 0 1 0 5.398l-.17.284a5.8 5.8 0 0 0-.625-1.648l-3.92-6.761c-.512-.91-.74-1.932-.74-2.955-4.147 1.08-7.045 3.41-7.045 6.08 0 3.75 5.568 6.762 12.444 6.762 6.875 0 12.444-3.012 12.444-6.762.056-2.557-2.785-4.887-6.99-5.966"></path></svg>`;
const cl_banco_scotiabank = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" class="w-8 h-8 rounded-[3px]"><rect width="32" height="32" fill="#EC121F" rx="3"></rect><g fill="#F5F5F5"><path d="M21.574 9.894H16a6.179 6.179 0 0 0-6.14 5.492h-.001a6.178 6.178 0 0 1 5.41-9.163h9.62l-3.314 3.671M10.425 22.25H16a6.179 6.179 0 0 0 6.14-5.491h.001a6.177 6.177 0 0 1-5.41 9.163h-9.62l3.314-3.672"></path><path d="M20.96 16.073a4.962 4.962 0 1 1-9.924 0 4.962 4.962 0 0 1 9.924 0"></path></g></svg>`;

type BankKey =
  | 'cl_banco_itau'
  | 'cl_banco_estado'
  | 'cl_banco_bci'
  | 'cl_banco_de_chile'
  | 'cl_banco_santander'
  | 'cl_banco_scotiabank'
  | 'cl_banco_falabella';

// 2. Create the Lookup Map
const BANK_SVG_MAP: Record<BankKey, string> = {
  'cl_banco_itau': cl_banco_itau,
  'cl_banco_estado': cl_banco_estado,
  'cl_banco_bci': cl_banco_bci,
  'cl_banco_de_chile': cl_banco_de_chile,
  'cl_banco_santander': cl_banco_santander,
  'cl_banco_scotiabank': cl_banco_scotiabank,
  'cl_banco_falabella': cl_banco_falabella
};
export const getBankSvg = (bankKey: BankKey) => {
  return BANK_SVG_MAP[bankKey];
};
